const PENDING_ORG_KEY = "lion_pro_org_join_pending";

export interface PendingOrgJoin {
  id: string;
  name: string;
  domain: string;
  logoUrl?: string | null;
  description?: string | null;
  city?: string | null;
  state?: string | null;
}

/** Demo pre-approved orgs by email domain (replace with API later). */
export const PREAPPROVED_ORGS_BY_DOMAIN: Record<
  string,
  { id: string; name: string; initials: string; memberHint: string; defaultRole: string }
> = {
  "lionenergy.com": {
    id: "lion-energy",
    name: "Lion Energy",
    initials: "LE",
    memberHint: "Fleet Management",
    defaultRole: "Viewer",
  },
  "acme.com": {
    id: "acme",
    name: "Acme Corp",
    initials: "AC",
    memberHint: "47 members · Fleet Management",
    defaultRole: "Viewer",
  },
};

export function getEmailDomain(email: string): string {
  const at = email.lastIndexOf("@");
  if (at < 0) return "";
  return email.slice(at + 1).trim().toLowerCase();
}

export function getPreapprovedOrgForEmail(email: string) {
  const domain = getEmailDomain(email);
  if (!domain) return null;
  const org = PREAPPROVED_ORGS_BY_DOMAIN[domain];
  if (!org) return null;
  return { ...org, domain };
}

export function hasPendingOrgJoin(): boolean {
  if (typeof sessionStorage === "undefined") return false;
  return sessionStorage.getItem(PENDING_ORG_KEY) != null;
}

export function getPendingOrgJoin(): PendingOrgJoin | null {
  if (typeof sessionStorage === "undefined") return null;
  const raw = sessionStorage.getItem(PENDING_ORG_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as PendingOrgJoin;
  } catch {
    return null;
  }
}

export function setOrgJoinPending(org: PendingOrgJoin): void {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.setItem(PENDING_ORG_KEY, JSON.stringify(org));
}

export function clearOrgJoinPending(): void {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.removeItem(PENDING_ORG_KEY);
}

/** Merge session pending row with fresher org details when available. */
export function enrichPendingOrgJoin(
  pending: PendingOrgJoin,
  source?: {
    logoUrl?: string | null;
    description?: string | null;
    city?: string | null;
    state?: string | null;
  } | null,
): PendingOrgJoin {
  if (!source) return pending;
  return {
    ...pending,
    logoUrl: pending.logoUrl ?? source.logoUrl ?? null,
    description: pending.description ?? source.description ?? null,
    city: pending.city ?? source.city ?? null,
    state: pending.state ?? source.state ?? null,
  };
}
